import { render, staticRenderFns } from "./NlDropdown.vue?vue&type=template&id=189f53d3&scoped=true&"
import script from "./NlDropdown.vue?vue&type=script&lang=js&"
export * from "./NlDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189f53d3",
  null
  
)

export default component.exports